import {FC, useMemo} from 'react'
import PreviewCanvas from "./_PreviewCanvas";
import PreviewImage from "./_PreviewImage";
import {buildExternalTree, ExternalFileInput, ExternalPayload, PreviewEntry} from "./BimboShareFolders";

type BimboShareExternalPreviewModalProps = {
    show: boolean
    handleClose: () => void
    title: string
    files: ExternalFileInput[]
    startIndex: number
}

const BimboShareExternalPreviewModal: FC<BimboShareExternalPreviewModalProps> = ({
    show,
    handleClose,
    title,
    files,
    startIndex,
}) => {
    const tree = useMemo(() => buildExternalTree(files), [files])
    const startKey = tree.entries[startIndex]?.key

    const renderImage = (entry: PreviewEntry<ExternalPayload>) =>
        entry.payload.file.isImage && entry.payload.file.previewUrl
            ? <PreviewImage src={entry.payload.file.previewUrl} alt={entry.name}/>
            : <PreviewImage alt={entry.name} fallbackIcon="fa-regular fa-file"/>

    const renderDetails = (entry: PreviewEntry<ExternalPayload>) =>
        <h6 className="name">{entry.name}</h6>

    return <PreviewCanvas
        show={show}
        handleClose={handleClose}
        title={title}
        tree={tree}
        startKey={startKey}
        renderImage={renderImage}
        renderDetails={renderDetails}
    />
}

export default BimboShareExternalPreviewModal
